export const dateFormat = (timestamp) => {
  const date = new Date(timestamp * 1000); // convert to ms

  // Format: "Jan 15 at 11:00 PM"
  const options = {
    month: "short", // Jan
    day: "numeric", // 15
    hour: "numeric", // 11
    minute: "2-digit", // 00
    hour12: true, // AM/PM format
  };

  const formatted = date.toLocaleString("en-US", options).replace(",", " at");
  return formatted;
};
